import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const Remittances = lazyLoad(
    () => import('./index'),
    module => module.Remittances,
    { fallback: <LoadingSpinner /> },
);
